import styled, { css, keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

export const ToastContainer = styled.div`
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  display: none;
  flex-direction: column;
  padding: 1rem;
  gap: 0.5rem;
  max-width: 420px;
  width: 100%;

  @media (min-width: 640px) {
    display: flex;
    bottom: 0;
    top: auto;
  }
`;

export const ToastViewport = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 0.5rem;
  width: 100%;
  max-width: 420px;
  margin: 0;
  list-style: none;
  z-index: 9999;
  outline: none;
`;

export const Toast = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  background-color: white;
  border-radius: 0.375rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.2), 0 2px 4px -1px rgba(0, 0, 0, 0.08);
  padding: 1rem;
  border-left: 4px solid;
  animation: ${slideIn} 0.2s ease-out;

  ${(props) =>
    props.variant === 'default' &&
    css`
      border-left-color: #3b82f6;
    `}

  ${(props) =>
    props.variant === 'destructive' &&
    css`
      border-left-color: #ef4444;
    `}
`;

export const ToastTitle = styled.div`
  font-weight: 600;
  font-size: 0.875rem;
  color: #111827;
  margin-bottom: 0.25rem;
`;

export const ToastDescription = styled.div`
  font-size: 0.875rem;
  color: #6b7280;
`;

export const ToastClose = styled.button`
  background: none;
  border: none;
  padding: 0.25rem;
  cursor: pointer;
  color: #9ca3af;
  border-radius: 0.25rem;

  &:hover {
    background-color: #f3f4f6;
    color: #6b7280;
  }
`;
